import { Notice, Separator } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import BasePollableLoginStore from '../../stores/BasePollableLoginStore';
import useStores from '../../stores/UseStores';

interface ServiceStatusNoticeProps {
  pollableLoginStore: BasePollableLoginStore;
}

const ServiceStatusNotice = (props: ServiceStatusNoticeProps): React.JSX.Element | null => {
  const {
    translateStore: { translate },
  } = useStores();
  const { pollableLoginStore } = props;

  let message: string;
  switch (pollableLoginStore.statusNotice) {
    case 'CRITICAL':
    case 'WARNING':
      message = translate(`${pollableLoginStore.service}.status.warning`);
      break;
    default:
      return null;
  }

  return (
    <>
      <Notice type={'error'}>
        <p role="alert">{message}</p>
      </Notice>
      <Separator color={'invisible'} spacing={'xsmall'} />
    </>
  );
};

export default observer(ServiceStatusNotice);
